const CorporateBorder = () => <div className="corporate_border"></div>;
export default CorporateBorder;
